import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=d5058bb0&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=ts&"
export * from "./Bottom.vue?vue&type=script&lang=ts&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=d5058bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5058bb0",
  null
  
)

export default component.exports